import { TagsEditor, TagsEditorState } from '@tableau/vizportalclient-common-components';
import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { SearchSuggestionsService } from '~src/content/services/SearchSuggestionsService';
import { ListResult } from '~src/ts/fetchers/ListResult';
import { ITag } from '~src/ts/ServerApi/types/ITag';

export type ChangeTagsDialogBodyProps = {
  description: string;
  itemCount: number;
}

export type ChangeTagsDialogProps = ReactActionDialogBodyProps<ChangeTagsDialogBodyProps, TagsEditorState>;

function handleFilterItems(partialText: string): Promise<readonly string[]> {
  return SearchSuggestionsService.tags(partialText)
      .getSlice(0, 10)
      .then((result: ListResult<ITag>) => {
        return result.items.map((value: ITag) => value.name);
  });
}

export function ChangeTagsDialogBody(props: ChangeTagsDialogProps): JSX.Element {
  return <TagsEditor
    editorState={props.dialogState}
    setEditorState={props.updateDialogState}
    searchMatchingTags={handleFilterItems}
    disableEditor={props.actionBusy}
    label={props.description}
    itemCount={props.itemCount}
  />;
}

